import { API_BASE as BASE } from '../lib/env';

export interface GlobalStats {
  totalMeasurements: number;
  totalSessions: number;
  totalDistanceM: number;
  operatorCounts: { operator: string; count: number }[];
  generationCounts: { generation: string; count: number }[];
  mosBuckets: { bucket: string; count: number }[];
  rsrpBuckets: { bucket: string; count: number }[];
  topCells: { ci: number | null; pci: number | null; tac: number | null; operator: string | null; networkGeneration: string | null; sightings: number }[];
  avgDownloadMbps: number | null;
  avgUploadMbps: number | null;
  avgLatencyMs: number | null;
  avgMos: number | null;
}

export async function fetchGlobalStats(): Promise<GlobalStats> {
  const r = await fetch(`${BASE}/stats/global`);
  if (!r.ok) throw new Error(`/stats/global ${r.status}`);
  return r.json();
}
